import React from 'react'
import {
    Box,
    Text,
    Icon,
    Flex,
    Spinner,
    Badge
} from "@chakra-ui/react";
import { useStore } from '../../Store';

export const OptionCard = ({ icon, title, description, onClick, jobKey, isPro, isVideo=false, isAI = false }) => {
    const { isJobInProgress } = useStore((state) => state)
    const loading = isJobInProgress(jobKey);
    return (
        <Box
            w="100%"
            bg="gray.100"
            borderRadius="lg"
            p={6}
            display="flex"
            cursor={loading ? "not-allowed" : "pointer"}
            // cursor={loading || (!isPro && isVideo) ? "not-allowed" : "pointer"}
            // pointerEvents={!isPro && isVideo ? "none" : "auto"}
            transition="transform 0.2s"
            _hover={{ transform: loading ? "none" : "scale(1.05)" }}
            opacity={loading ? 0.6 : 1}
            onClick={loading ? null : onClick}
        >
            <Flex align="start">
                <Icon as={icon} boxSize={6} color="blue.500" mt={1} mr={4} />
                <Box>
                    <Flex alignItems="center">
                        <Text fontWeight="bold" fontSize="md">{title}</Text>
                        {
                            (!isPro && isVideo) ?
                            <Badge variant="solid" colorScheme="blue" ml={2}>
                                Pro
                            </Badge> : null
                        }
                        {isAI ? (
                            <Badge variant="solid" bg="blue.500" ml={2}>
                                AI
                            </Badge>
                        ) : null}
                    </Flex>
                    <Text fontSize="sm" mt={1} color="gray.600">
                        {loading ? <Spinner size="sm" mr={2} /> : null}
                        {loading ? "Creating..." : description}
                    </Text>
                </Box>
            </Flex>
        </Box>
    )
}
